import store from '../../../store'

async function updateUserSubscription (data) {
  console.log('Received subscriptionChanged event')
  const message = data.subscription
  const { apiPlan, plan } = message

  const currentSubscription = store.getters['AuthModule/getUserSubscription']
  const newSubscription = {
    ...currentSubscription,
    ...plan,
    addOns: plan?.addOns
  }


  const newSpyderLimit = plan?.addOns?.spyder?.quantity
  const newLensLimit = plan?.addOns?.lens?.quantity

  store.commit('AuthModule/SET_APP_LIMITS', { spyder: newSpyderLimit, lens: newLensLimit })
  store.commit('AuthModule/SET_USER_SUBSCRIPTION', newSubscription)
  store.commit('AuthModule/SET_EXTERNAL_SUBSCRIPTION', apiPlan)
}

export default async function stripeSetup (socket) {
  socket.on('subscriptionChanged', updateUserSubscription)
}
